import {HttpClient} from "@angular/common/http";
import {PathService} from "../../login/services/path.service";
import {PaginationArgs, PaginationPage} from "../models/pagination.args";
import {Observable} from "rxjs";
import {PubDtoModel} from "../models/pub.dto.model";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class PubService {

    private baseUrl: string = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/pubs`;
    }

    public findAllPubsDTO(paginationArgs: PaginationArgs): Observable<PaginationPage<PubDtoModel>> {
        return this.http.get<PaginationPage<PubDtoModel>>(`${this.baseUrl}?page=${paginationArgs.pageNumber}&size=${paginationArgs.pageSize}`);
    }

    public persistPub(newPub: PubDtoModel): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}`, newPub);

    }

    public updatePub(selectedPub: PubDtoModel): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}`, selectedPub);
    }

    public deletePub(uuid: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${uuid}`);

    }
}
